module.exports = __webpack_public_path__ + "static/media/menu.dd38b95e.svg";